<footer class="py-4 text-sm text-slate-600 dark:text-slate-400 border-t border-slate-200 dark:border-slate-800 bg-white">
  <div class="container-fluid flex items-center justify-between">
    <div>
      {{ year }} © OTTWO
    </div>
    <div class="hidden sm:block text-sm text-right text-slate-500 dark:text-slate-400">
      Stockistly
    </div>
  </div>
</footer>